import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { UserRole } from '../../types/auth';

interface RoleGuardProps {
  children: React.ReactElement;
  allowedRoles: UserRole[];
}

/** Landing page for each role. */
export const roleHomePath = (role: UserRole | null | undefined) =>
  role === 'Admin' ? '/admin-dashboard' : role === 'Supervisor' ? '/supervisor-dashboard' : '/manage-campaigns';

export const RoleGuard: React.FC<RoleGuardProps> = ({ children, allowedRoles }) => {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="p-5 text-center text-muted">Checking user authorization...</div>;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  // Signed in with a role this page isn't for -> that role's own dashboard.
  if (!allowedRoles.includes(user.role)) {
    return <Navigate to={roleHomePath(user.role)} replace />;
  }

  return children;
};
